import { stringify } from "query-string"

import { farasod } from "./api"

const endpoint = "/payment"

export const getPayments = async queries => {
  const query = stringify(queries, { skipEmptyString: true, skipNull: true })

  const response = await farasod.get(`${endpoint}?${query}`)

  return response.data
}

export const getPaymentReports = async queries => {
  const query = stringify(queries,
    { skipEmptyString: true, skipNull: true }
  )

  const response = await farasod.get(`${endpoint}/report/statistic?${query}`)

  return response.data
}

export const pay = async data => {
  const response = await farasod.post(`${endpoint}`, data)

  return response.data
}

export const getPromotionPackageUsage = async couponCode => {
  const response = await farasod.get(`${endpoint}/topupCoupon/${couponCode}/usage`)

  return response.data
}

export const getPromotionPackageUsageList = async (couponCode, queries) => {
  const query = stringify(queries, {
    skipEmptyString: true, skipNull: true
  })

  const response = await farasod.get(`${endpoint}/topupCoupon/${couponCode}/list?${query}`)

  return response.data
}

export const topupPaymentServiceOwner = async data => {
  const response = await farasod.post(`${endpoint}/topup/serviceOwner`, data)

  return response.data
}

export const billplzPaymentStatus = async billId => {
  const response = await farasod.get(`${endpoint}/billId/${billId}`)

  return response.data
}

export const createSmsPayment = async data => {
  const response = await farasod.post(`${endpoint}/sms`, data)

  return response.data
}

export const sendZarinpalPaymentResult = async queries => {
  const query =
    stringify(
      queries,
      {
        skipEmptyString: true,
        skipNull: true
      }
    )

  const isMaster =
    String(process.env.REACT_APP_PAYMENT_RESULT_IS_MASTER || "true")
      .toLowerCase() !== "false"

  const sandbox = isMaster ? "" : "/fake"

  const response = await farasod.get(
    `${endpoint}/result/zarinpal${sandbox}?${query}`,
    { headers: { "X-Payment-Result-Response": "json" } }
  )

  return response.data
}

export const verifyOrderGatewayPayment = async (orderId, branchId) => {
  const response = await farasod.post(
    `${endpoint}/verify/order/${orderId}`,
    { branchId }
  )

  return response.data
}

export const getAvailablePaymentGateways = async () => {
  const response = await farasod.get(`${endpoint}/available-gateways`)

  return response.data
}

export const sendPaymentFollowUpSms = async (orderId, text) => {
  const response = await farasod.post(
    `${endpoint}/smsPaymentLink/${orderId}`,
    { text }
  )

  return response.data
}
